import {
  Modal as MUIModal,
  Typography,
  Button,
  Box,
  Stack,
  Link,
  TextareaAutosize,
} from "@mui/material";
import { ModalCloseIcon, RightArrowIcon, ThumbsUpIcon } from "../../@lib/icons";
import { useLanguageTranslator } from "../useLanguageContext";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 530,
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  py: 3,
  px: 1,
};

function ConfirmationApprovedModal({
  isOpen,
  handleClose,
  text = "",
  onClickHandler,
  viewPath = "",
  item,
}: any) {
  const { translator } = useLanguageTranslator();

  return (
    <div>
      <MUIModal
        open={isOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack
            sx={{ display: "flex", justifyContent: "end", alignItems: "end" }}
          >
            <Button
              onClick={handleClose}
              sx={{ padding: "0px", minWidth: "auto" }}
            >
              <ModalCloseIcon />
            </Button>
          </Stack>
          <Stack
            direction="column"
            sx={{ padding: "10px 60px" }}
            alignItems="center"
          >
            <ThumbsUpIcon />
            <Typography id="modal-modal-title" sx={{ fontSize: "16px" }}>
              {translator(`rejectionMessage`, {
                text: translator(`confirmationItems.${text}`),
              })}
            </Typography>
            <Typography
              id="modal-modal-description"
              variant="h6"
              component="h2"
              sx={{ fontSize: "16px" }}
            >
              {translator("Do you want to change its status to Approved?")}
            </Typography>
          </Stack>
          <Stack direction="row" justifyContent="center" gap={1} mt={2}>
            <Button
              sx={{
                backgroundColor: "#52D777",
                "&:hover": {
                  backgroundColor: "#3BAA50",
                },
                color: "white",
                padding: "7px 50px",
              }}
              onClick={() => onClickHandler(item)}
            >
              {translator("status.Approve")}
            </Button>
            <Button
              onClick={handleClose}
              sx={{
                backgroundColor: "#989C9F",
                "&:hover": {
                  backgroundColor: "#D9534F",
                },
                color: "white",
                padding: "7px 50px",
              }}
            >
              {translator("Cancel")}
            </Button>
          </Stack>
          <Link
            id="modal-modal-description"
            href={viewPath}
            sx={{
              mt: 2,
              color: "#F6A000",
              fontSize: "14px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {translator(`footerTextReview`, {
              text: translator(`confirmationItems.${text}`),
            })}{" "}
            <div style={{ marginLeft: "10px" }}>
              <RightArrowIcon />
            </div>
          </Link>
        </Box>
      </MUIModal>
    </div>
  );
}

export { ConfirmationApprovedModal };
